import React, { useState } from 'react';

interface Contact {
  name: string;
  number: string;
}

export default function Contato() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const contacts: Contact[] = [
    { name: 'Diego', number: '5569993737919' },
    { name: 'Marcos', number: '5569993521220' }
  ];

  const whatsappMessage = 'Olá! Gostaria de saber mais sobre os serviços da AGROINVEST.';
  
  const openWhatsApp = (contact: Contact) => {
    const whatsappUrl = `https://wa.me/${contact.number}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappUrl, '_blank');
    setIsModalOpen(false);
  };

  return (
    <div className="py-8">
      <div className="container-custom">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-3xl font-bold mb-8">Entre em Contato</h1>
          
          <div className="card mb-8">
            <h2 className="text-xl font-semibold mb-4">Nosso Escritório</h2>
            <p className="text-gray-600 mb-2">Rua Foz do Iguaçu, 1800, Sala-A</p>
            <p className="text-gray-600 mb-4">Buritis - RO</p>
            
            <h3 className="text-lg font-semibold mb-2">Horário de Atendimento</h3>
            <p className="text-gray-600 mb-4">Segunda a Sexta: 8h às 18h</p>
            
            <h3 className="text-lg font-semibold mb-2">Contatos</h3>
            <p className="text-gray-600 mb-2">
              WhatsApp Diego: +55 (69) 99373-7919
            </p>
            <p className="text-gray-600 mb-2">
              WhatsApp Marcos: +55 (69) 99352-1220
            </p>
          </div>

          <div className="text-center">
            <h2 className="text-xl font-semibold mb-4">Fale Conosco pelo WhatsApp</h2>
            <p className="text-gray-600 mb-6">
              Clique no botão abaixo para iniciar uma conversa com nossa equipe
            </p>
            <button
              onClick={() => setIsModalOpen(true)}
              className="inline-flex items-center justify-center bg-green-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-600 transition-colors"
            >
              <svg
                className="w-6 h-6 mr-2"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
                />
              </svg>
              Iniciar Conversa
            </button>
          </div>

          {/* Modal de seleção de contato */}
          {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
                <h3 className="text-xl font-semibold mb-4">Escolha um contato</h3>
                <div className="space-y-3">
                  {contacts.map((contact) => (
                    <button
                      key={contact.number}
                      onClick={() => openWhatsApp(contact)}
                      className="w-full text-left p-3 rounded-lg hover:bg-gray-100 transition-colors flex items-center"
                    >
                      <svg
                        className="w-6 h-6 mr-3 text-green-500"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                      </svg>
                      Falar com {contact.name}
                    </button>
                  ))}
                </div>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="mt-4 w-full bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors"
                >
                  Cancelar
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
} 